import React from 'react'

import PropTypes from 'prop-types'

import { IconButton } from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

import { InfoTileCard, InfoTileCardContent } from '../../styles/components/InfoTileStyle'
import statisticsApi from '../../api/statistics'
import useHandleError from '../../api/useHandleError'

const AddNewTile = ({ tiles, setTiles }) => {
  const handleError = useHandleError()

  const createTile = async () => {
    const name = `Tile ${tiles.length + 1}`
    const newTileData = await statisticsApi
      .createTile(name)
      .then((data) => data.data)
      .catch(handleError)
    setTiles([...tiles, newTileData])
    return newTileData
  }

  return (
    <InfoTileCard aria-label="addNewTile">
      <InfoTileCardContent>
        <IconButton onClick={createTile} aria-label="addTileButton">
          <AddCircleOutlineIcon />
        </IconButton>
      </InfoTileCardContent>
    </InfoTileCard>
  )
}

AddNewTile.propTypes = {
  tiles: PropTypes.array,
  setTiles: PropTypes.func,
}

export default AddNewTile
